import React, {useState} from "react";
import { Box, Paper } from "@mui/material";
// import {styled} from "@mui/material/styles";
import Modal from '@mui/material/Modal'


export const EventPaper = (props) => {
    const [hovered, setHovered] = useState(false);

    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 400,
        bgcolor: 'background.paper',
        border: '2px solid #000',
        boxShadow: 24,
        pt: 2,
        px: 4,
        pb: 3,
    };
    const [open, setOpen] = React.useState(false);
    const handleOpen = () => {
        setOpen(true);
    };
    const handleClose = () => {
        setOpen(false);
    };


    return (
        <React.Fragment>

        <Paper
            elevation={hovered ? 12 : 1} // change elevation on hover
            onMouseEnter={() => setHovered(true)}
            onMouseLeave={() => setHovered(false)}

            onClick={handleOpen}
            className="timeline-item"

            sx={{
                padding: 2,
                textAlign: "center",
                transition: "all 0.3s ease", // smooth shadow transition
                cursor: "pointer",
            }}

        >
            {props.children}
        </Paper>


            {/*<Modal*/}
            {/*    open={open}*/}
            {/*    onClose={handleClose}*/}
            {/*    aria-labelledby="parent-modal-title"*/}
            {/*    aria-describedby="parent-modal-description"*/}
            {/*>*/}
            {/*    <Box sx={{ ...style, width: 400 }}>*/}
            {/*        {props.children}*/}

            {/*    </Box>*/}
            {/*</Modal>*/}

        </React.Fragment>
    );
};

